import { Entity } from '@backstage/catalog-model';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { isDevlakeSquad } from '../shared/devlakeSquad';

// DevLake squads open on DORA metrics, so their Overview tab is hidden.
export const catalogOverviewContent = catalogPlugin
  .getExtension('entity-content:catalog/overview')
  .override({
    params: { filter: (entity: Entity) => !isDevlakeSquad(entity) },
  });

export const devlakeDoraContent = EntityContentBlueprint.make({
  name: 'devlake-usage',
  params: {
    path: '/',
    title: 'DORA metrics',
    group: 'devlake-dora',
    filter: isDevlakeSquad,
    loader: async () => {
      const { DashboardContent } = await import('./DashboardContent');
      return <DashboardContent />;
    },
  },
});

export const devlakeDashboardModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [catalogOverviewContent, devlakeDoraContent],
});
